export default function FlightResultsSortTypes(l10nService) {
    'ngInject';

    return {
        CHEAPEST: {
            text: l10nService.localize('Cheapest'),
            value: 0,
        },
        QUICKEST: {
            text: l10nService.localize('Quickest'),
            value: 1,
        },
        EARLIEST: {
            text: l10nService.localize('Earliest'),
            value: 2,
        },
        GREENEST: {
            text: l10nService.localize('Greenest'),
            value: 3,
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/services/flight-results-sort-types.js